import React, { useEffect, useState } from "react";
import "./App.scss";
import { useSelector, RootStateOrAny, useDispatch } from "react-redux";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeflex/primeflex.scss";
import "primeicons/primeicons.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Overview from "./pages/Overview";
import History from "./pages/History";
import Assing_managment from "./pages/Assing_managment";
import { Header } from "./container/Header";
import { Footer } from "./container/Footer";
import { OurPeople } from "pages/OurPeople";
import ContactUs from "pages/ContactUs";
import { CommunityImpect } from "pages/communityImpact";
import { SocialResponsibility } from "pages/SocialResponsibility";
import { Clients } from "pages/clients";
import { Insights } from "pages/insights";
import { InvestorServices } from "pages/Investor_Services";
import FooterForm from "container/Footer/footerForm";
// import footerForm from "container/Footer/footerForm";
import {
  fetchDashboardData,
  resetError,
} from "./redux-new/features/dashboardSlice";
import {
  fetchClientsData,
  resetError as resetClientsError,
} from "./redux-new/features/clientsSlice";
import {
  fetchBlogsData,
  fetchBlogById,
  resetError as resetBlogsError,
} from "./redux-new/features/blogsSlice";
import {
  fetchAboutOverviewData,
  resetError as resetAboutOverviewError,
} from "./redux-new/features/aboutOverviewSlice";
import {
  fetchAboutHistoryData,
  resetError as resetAboutHistoryError,
} from "./redux-new/features/aboutHistorySlice";
import {
  fetchourServiceData,
  resetError as resetOurServicesError,
} from "./redux-new/features/ourServicesSlice";
import {
  fetchinvesterServiceData,
  resetError as resetInvesterServiceError,
} from "./redux-new/features/investerServicesSlice";
import {
  fetchDeveloperServiceData,
  resetError as resetDeveloperServiceError,
} from "./redux-new/features/developerServiceSlice";
import {
  fetchOtherServiceData,
  resetError as otherServiceDataError,
} from "./redux-new/features/otherServiceSlice";
import {
  fetchOurPeopleData,
  resetError as resetOurPeopleError,
} from "./redux-new/features/ourPeopleSlice";
import {
  fetchJobsData,
  resetError as resetJobsError,
} from "./redux-new/features/jobSlice";

import { DeveloperServices } from "pages/Developer_Services";
import { OtherServices } from "pages/Other_Services";

import Careers from "pages/Carrers";
import { Our_services } from "pages/Our-services";
import { InsightsDetails } from "pages/insights-details";
import { ProjectListing } from "pages/insights/ProjectListing";
import JobDetails from "pages/Carrers/JobDetails";
import { InsightsDetails2 } from "pages/insights-details/insightsDetails2";
import Admin from "pages/insights/Admin";
import Testing from "pages/Testing/Testing";
import ScrollToTop from "pages/Testing/ScrollToTop";
import AOS from "aos";
import "aos/dist/aos.css";
import { fetchProjects } from "redux-new/features/projectSlice";
import { fetchClientPage, resetError as resetClientPageError } from "redux-new/features/clinetPageSlice";
import { fetchSocialResponsibilityData, resetError as resetSocialResponsibilityError } from "redux-new/features/socialResponsibilitySlice";
const App = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAboutOverviewData());
    return () => {
      dispatch(resetAboutHistoryError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchJobsData());
    return () => {
      dispatch(resetJobsError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchOurPeopleData());
    return () => {
      dispatch(resetOurPeopleError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchourServiceData());
    return () => {
      dispatch(resetOurServicesError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchOtherServiceData());
    return () => {
      dispatch(otherServiceDataError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchinvesterServiceData());
    return () => {
      dispatch(resetInvesterServiceError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchDeveloperServiceData());
    return () => {
      dispatch(resetDeveloperServiceError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAboutHistoryData());
    return () => {
      dispatch(resetAboutOverviewError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchDashboardData());
    return () => {
      dispatch(resetError()); // Reset error on unmount if needed
    };
  }, [dispatch]);
  useEffect(() => {
    dispatch(fetchProjects());
    return () => {
      dispatch(resetError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchClientsData());
    return () => {
      //test comment
      dispatch(resetClientsError()); // Reset error on unmount if needed
    };
  }, [dispatch]);

  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);

  useEffect(() => {
    dispatch(fetchBlogsData());
    return () => {
      dispatch(resetError()); // Reset error on unmount
    };
  }, [dispatch]);
  useEffect(() => {
    dispatch(fetchClientPage());
    return () => {
      dispatch(resetClientPageError()); // Reset error on unmount
    };
  }, [dispatch]);
  useEffect(() => {
    dispatch(fetchSocialResponsibilityData());
    return () => {
      dispatch(resetSocialResponsibilityError()); // Reset error on unmount
    };
  }, [dispatch]);

  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY === 0) {
        // User is at the top of the page
        setShowHeader(true);
      } else if (currentScrollY > lastScrollY) {
        // User is scrolling down
        setShowHeader(false);
      } else {
        // User is scrolling up
        setShowHeader(true);
      }

      // Update last scroll position
      setLastScrollY(currentScrollY);

      // Clear timeout to hide header
      clearTimeout(window.hideHeaderTimeout);
      window.hideHeaderTimeout = setTimeout(() => {
        if (currentScrollY > lastScrollY) {
          setShowHeader(false);
        }
      }, 1500);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(window.hideHeaderTimeout);
    };
  }, [lastScrollY]);

  return (
    <Router>
      <ScrollToTop />
      <div style={{ paddingTop: "50px", zIndex: 999999 }}>
        <div
          className={`w-full  ${
            showHeader ? "header-slide-in" : "header-slide-out"
          }`}
          style={{
            position: "fixed",
            zIndex: 999,
            top: 0,
            backgroundColor: "transparent",
          }}
        >
          <div className=" ">
            <Header />
          </div>
        </div>
      </div>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/our-people" element={<OurPeople />}></Route>
        <Route path="/history" element={<History />} />
        <Route path="/assignmen_managment" element={<Assing_managment />} />
        <Route path="/community_impect" element={<CommunityImpect />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/investor-services" element={<InvestorServices />} />
        <Route path="developer-services" element={<DeveloperServices />} />
        <Route path="/other-services" element={<OtherServices />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/job-details/:id" element={<JobDetails />} />
        <Route path="/our-services" element={<Our_services />} />
        <Route path="/insights-details/:id" element={<InsightsDetails />} />
        <Route path="/insights-details-new" element={<InsightsDetails2 />} />
        <Route path="/project-listing" element={<ProjectListing />} />
        <Route path="/Testing" element={<Testing />} />
        <Route path="/footerForm" element={<FooterForm />} />

        <Route
          path="/social_responsibility"
          element={<SocialResponsibility />}
        />
        <Route path="/clients" element={<Clients />} />
      </Routes>
      <div style={{ width: "100%", zIndex: 99999 }}>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
